module.exports = [
    {
        id: "SAYESC",
        thumbnail: 'sayulita-escape.jpg',
        detail: {
            slider: [{
                image: '1.jpg'
            },
            {
                image: '2.jpg'
            },
            {
                image: '3.jpg'
            },
            {
                image: '4.jpg'
            }, 
            {
                image: '5.jpg'
            }]
        }
    },
    {
        id: "SEBASTIAN",
        thumbnail: 'san-sebastian-tour-privado.jpg'
    },
    {
        id: "EXTREMEWITHFLIGHT",
        thumbnail: 'aventura-extrema.jpg'
    },
    {
        id: "OUTDORADV",
        thumbnail: 'outdoor-aventure.jpg'
    },
    {
        id: "WHALEPHOT",
        thumbnail: 'avistamiento-ballenas.jpg'
    },
    {
        id: "SEASAFARI",
        thumbnail: 'sea-safari-paseo-caballo.jpg'
    },
    {
        id: "RHYTHMSN",
        thumbnail: 'ritmos-de-la-noche-savia.jpg'
    },
    {
        id: "SUNSTSAIL",
        thumbnail: 'velero-de-lujo-atardecer.jpg'
    },
    {
        id: "MARIETAS",
        thumbnail: 'islas-marietas.jpg'
    },
    {
      id: "LEARNDIVE"
    },
    {
      id: "LASCALETS"
    },
    {
      id: "DSDCALETAS"
    },
    {
      id: "LUXRYSAIL"
    },
    {
      id: "YELAPAMAJ"
    },
    {
      id: "BUBBLEMAK"
    },
    {
      id: "PADIOPWA"
    },
    {
      id: "PADICERT"
    },
    {
      id: "REFRESHER"
    },
    {
      id: "CALETDIVETWOTKS"
    },
    {
      id: "ANEGADOS"
    },
    {
      id: "ELMORRODV"
    },
    {
      id: "MARIEDIVETWOTKS"
    },
    {
      id: "ARCOSDAYC"
    },
    {
      id: "DOLEXT"
    },
    {
      id: "DOLPSIGSW"
    },
    {
      id: "DOLPSWMEX"
    },
    {
      id: "DOLPENCTR"
    },
    {
      id: "DOLPKIDS"
    },
    {
      id: "TRAINER"
    },
    {
      id: "SEALIONEN"
    },
    {
      id: "ADRENALINEBAY"
    },
    {
      id: "THRILLER"
    },
    {
      id: "ISLANDDIS"
    },
    {
      id: "CALETASANDOLP"
    },
    {
      id: "LUXYACHTSNORKEL"
    },
    {
      id: "ALLTERRAINno"
    },
    {
      id: "RHYTHMSVIP"
    },
    {
      id: "WRECKDIVE"
    },
    {
      id: "PARASAILING"
    },
    {
      id: "PUEBLOS"
    },
    {
      id: "SEBASTIAN"
    }
]